import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import SEO from '../../components/SEO';
import { useAuth } from '../../context/AuthContext';
import './AuthPage.css';

function SignInPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const next = params.get('next') || '/account';

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      await login(email.trim(), password);
      navigate(next, { replace: true });
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-page">
      <SEO title="Sign in" description="Sign in to your ASG Shading account to view your orders and saved details, or reset your password if you have forgotten it." canonical="/sign-in" noindex />
      <div className="auth-card">
        <p className="auth-eyebrow">ASG Shading</p>
        <h1 className="auth-title">Welcome back</h1>
        <p className="auth-subtitle">Sign in to see your orders, save your details, and check out faster.</p>
        <form className="auth-form" onSubmit={handleSubmit}>
          <div className="auth-field">
            <label htmlFor="email">Email</label>
            <input id="email" type="email" autoComplete="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          <div className="auth-field">
            <label htmlFor="password">Password</label>
            <input id="password" type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} />
          </div>
          {error && <p className="auth-error" role="alert">{error}</p>}
          <button type="submit" className="auth-btn" disabled={submitting}>
            {submitting ? 'Signing in…' : 'Sign in'}
          </button>
          <div className="auth-meta">
            <Link to="/forgot-password">Forgot password?</Link>
            <Link to={`/sign-up${next !== '/account' ? `?next=${encodeURIComponent(next)}` : ''}`}>Create an account →</Link>
          </div>
        </form>
      </div>
    </div>
  );
}

export default SignInPage;
